import { IconPlus, Menu, MenuItem, get, useMenuState } from '@vtex/admin-ui'
import { useWatch } from '@vtex/admin-ui-form'
import { useIntl } from 'react-intl'
import { useFormStateContext } from '../../../providers'
import { MenuButtonWithIcon } from '../MenuButtonWithIcon'
import { messages } from './messages'
import { useConditions } from './useConditions'
import { ConditionConfig } from './ConditionsContext'
import { useMemo } from 'react'

const getLabel = (condition: ConditionConfig): string =>
  (condition.label as string).toLowerCase()

export function AddConditionButton() {
  const { formatMessage: i18n } = useIntl()
  const state = useMenuState({
    placement: 'bottom-start',
    flip: false,
  })
  const { conditions } = useConditions()

  const { form } = useFormStateContext()

  // the useWatch hook exposed by admin-ui-form does not support the name param as `undefined`
  // although the original method by react-hook-form does (and delivers the root level data)
  const formValues = useWatch({ form, name: undefined as unknown as string })

  const availableOptions = useMemo(
    () =>
      conditions
        .filter(
          ({ name, hidden }) => get(formValues, name) === undefined && !hidden
        )
        .sort((a, b) => getLabel(a).localeCompare(getLabel(b))),
    [conditions, formValues]
  )

  if (!availableOptions.length) return

  return (
    <>
      <MenuButtonWithIcon
        state={state}
        variant="secondary"
        aria-label={i18n(messages.add)}
        icon={<IconPlus />}
        label={i18n(messages.add)}
      />
      <Menu state={state}>
        {availableOptions.map((config) => (
          <MenuItem
            key={config.name}
            label={config.label}
            icon={config.icon}
            onClick={config.onEdit}
          />
        ))}
      </Menu>
    </>
  )
}
